import { NUM_CATEGORIES } from '@mc/constants'
import { useTranslation } from '@mc/i18n'
import { getNumberOfInstructors } from '@mc/instructors'
import { TrackingContainer } from '@mc/visibility'

import { PricingText } from 'components/PricingText'
import CTA from 'components/CTA'

import { usePageData } from '../PageDataProvider'
import { trackCatalogPageRowViewed } from '../../events'

export const AccessAllClasses = () => {
  const { t } = useTranslation('@mc/next')

  const { slug } = usePageData()

  return (
    <TrackingContainer
      onFirstVisible={() =>
        trackCatalogPageRowViewed({
          rowName: 'sign_up_bottom_section',
          categorySlug: slug,
        })
      }
    >
      <div className='container mc-text--center mc-py-10'>
        <div>
          <h2 className='mc-text-h2'>
            {t('categories.categoryPage.accessAllClasses.title', {
              instructors: getNumberOfInstructors(),
              categories: NUM_CATEGORIES,
            })}
          </h2>
          <div className='mc-pb-4' />
          <h3 className='mc-text-medium mc-text--light'>
            <PricingText />
          </h3>
        </div>
        <div className='mc-pb-6' />
        <CTA
          trackProps={{
            content_type: 'product',
            location: 'sign_up_bottom_section',
            category: slug,
          }}
        />
      </div>
    </TrackingContainer>
  )
}
